export default __webpack_public_path__ + "static/media/i114hp.6dbd9e70.webp";